
(function(){
  function init(root){
    if(!root || root.dataset.msrReady==='true') return;
    root.dataset.msrReady='true';

    const filterToggle=root.querySelector('[data-msr-filter-toggle]');
    const filterPanel=root.querySelector('[data-msr-filter-panel]');
    const sort=root.querySelector('[data-msr-sort]');
    const filterForm=root.querySelector('[data-msr-filter-form]');

    if(filterToggle && filterPanel){
      filterToggle.addEventListener('click',()=>{
        const open=filterPanel.classList.toggle('is-open');
        filterToggle.setAttribute('aria-expanded',open?'true':'false');
      });
    }

    if(sort){
      sort.addEventListener('change',()=>{
        const url=new URL(window.location.href);
        if(sort.value) url.searchParams.set('sort_by',sort.value);
        else url.searchParams.delete('sort_by');
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    }

    if(filterForm){
      filterForm.addEventListener('submit',()=>{
        const pageInput=filterForm.querySelector('input[name="page"]');
        if(pageInput) pageInput.remove();
      });
    }
  }

  document.addEventListener('DOMContentLoaded',()=>{
    document.querySelectorAll('.mialica-search-results').forEach(init);
  });

  document.addEventListener('shopify:section:load',e=>{
    const root=e.target.querySelector('.mialica-search-results') ||
      (e.target.matches && e.target.matches('.mialica-search-results') ? e.target:null);
    if(root) init(root);
  });
})();
